<template>
  <div class="portfolio-dropdown">
    <select
      class="portfolio-select"
      v-model="selectedValue"
      @change="handleChange"
    >
      <option value="">No portfolio</option>
      <option
        v-for="option in portfolioOptions"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
    <icon name="chevron-down" class="portfolio-dropdown__icon"/>
  </div>
</template>

<script>
  import { defineComponent } from 'vue'
  import { Portfolios } from '../../api/portfolios'

  export default defineComponent({
    name: 'SimplePortfolioDropdown',
    data () {
      return {
        selectedValue: '',
        portfolioOptions: []
      }
    },
    emits: ['update:modelValue'],
    methods: {
      handleChange (event) {
        this.$emit('update:modelValue', event.target.value)
      },
      async fetchPortfolios () {
        try {
          const portfolios = await Portfolios.get()

          this.portfolioOptions = portfolios
            .filter(portfolio => !portfolio.virtual)
            .map(portfolio => ({
              label: portfolio.name,
              value: portfolio.id
            }))
        } catch (error) {
          console.error('Error fetching portfolios:', error)
        }
      }
    },
    mounted () {
      this.fetchPortfolios()
    }
  })
</script>

<style lang="scss" scoped>
  @import "../../../scss/_variables";

  .portfolio-dropdown {
    position: relative;
    min-width: 150px;
    display: inline-block;

    .portfolio-select {
      appearance: none;
      background: white;
      border: 1px solid $color-borders;
      border-radius: 0;
      padding: 4px 32px 4px 4px;
      width: 100%;
      font-size: 14px;
      color: #444;
      min-height: 36px;
      line-height: 18px;
      cursor: pointer;
      transition: none;

      &:hover {
        border-color: #aaa;
      }

      &:focus {
        outline: none;
        border-color: var(--primary-community);
        box-shadow: 0 0 0 2px var(--primary-community);
      }
    }

    .portfolio-dropdown__icon {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none;
      opacity: 0.5;
      width: 14px;
      height: 14px;

      path {
        fill: #444;
      }
    }

    &:hover .portfolio-dropdown__icon {
      opacity: 0.8;
    }
  }
</style>
